import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Col, Row } from 'antd';
import { injectIntl } from 'react-intl';
import { ticketActionStatus } from '../../../utils/app-configs';

export const StyledRow = styled(Row)`
  width: 100%;
`;

const SmartActionCardContent = ({ isWriteUser, isRequested, action, intl }) => {
  const renderInfoText = () => {
    if (isRequested) {
      return isWriteUser ?
        intl.formatMessage({ id: 'ticket.smart_actions.INFO_REQUESTED_WRITE' }) :
        intl.formatMessage({ id: 'ticket.smart_actions.INFO_REQUESTED_READ' });
    }
    return intl.formatMessage({ id: 'ticket.smart_actions.INFO_NOT_REQUESTED' });
  };

  const showStatus = () => {
    if (ticketActionStatus[action.status] === ticketActionStatus[512]) {
      return intl.formatMessage(
        { id: 'ticket.smart_actions.AUTO_CLOSED_SMART_ACTION' },
      );
    }
    return intl.formatMessage(
      { id: 'ticket.smart_actions.LINKED_STATUS' },
      { status: `"${ticketActionStatus[action.status]}"` },
    );
  };


  return (
    <>
      <StyledRow>
        <Col span={4}>
          <p>
            {`${intl.formatMessage({ id: 'ticket.smart_actions.STATUS' })}:`}
          </p>
        </Col>
        <Col span={20} data-test-id='smart-action-status'>
          {isRequested ?
            ticketActionStatus[action.status] :
            showStatus()
          }
        </Col>
      </StyledRow>
      <StyledRow>
        <Col span={4}>
          <p>
            {`${intl.formatMessage({ id: 'ticket.smart_actions.NEXT' })}:`}
          </p>
        </Col>
        <Col span={20}>
          {renderInfoText()}
        </Col>
      </StyledRow>
    </>
  );
};
SmartActionCardContent.propTypes = {
  intl: PropTypes.object,
  action: PropTypes.object,
  isRequested: PropTypes.bool,
  isWriteUser: PropTypes.bool,
};

export default injectIntl(SmartActionCardContent);
